// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__19eTf","container":"styles_container__2N2bw","title":"styles_title__1NMOc","wrapper":"styles_wrapper__1CZmj","answer":"styles_answer__2eTwL"};